import React, { FC } from "react";
interface ProgressBarProps {
  value: number;
  max: number;
}

export const ProgressBar: FC<ProgressBarProps> = ({ value, max }) => {
  const percentage = Math.round((value / max) * 100);

  return (
    <div className="relative w-64 h-6 bg-gray-200 rounded-lg overflow-hidden">
      <div
        className="h-full bg-green-500" // verde en lugar de azul
        style={{ width: `${percentage}%` }}
      />
      <span className="absolute inset-0 flex items-center justify-center text-sm font-medium text-white">
        {percentage}%
      </span>
    </div>
  );
};